import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import AcessTypeLayer from "../../components/SupportTicket/SupportTicketListLayer";


const SupportTicketList = () => {
  return (
    <>

      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="Help & Support Ticket" />

        {/* UsersListLayer */}
        <AcessTypeLayer />

      </MasterLayout>

    </>
  );
};

export default SupportTicketList; 
